// extracted by mini-css-extract-plugin
export default {"Action":"_Action--GWaeu","Icon":"_Icon--M6s95","Text":"_Text--k2LKb","Body":"_Body--K59e0"};